import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {googleServer} from "./commonVariable";

const useSessionRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const validateSession = async () => {
            try {
                const response = await fetch(`${googleServer}/user/session`, {
                    method: 'GET',
                    credentials: 'include',
                });

                if (response.status === 200) {
                    navigate('/welcome');
                } else {
                    navigate('/');
                }
            } catch (error) {
                console.error('Error checking session:', error);
                navigate('/');
            }
        };

        validateSession();
    }, [navigate]);
};

export default useSessionRedirect;